import { inject, Injectable } from '@angular/core';
import { Location, PlatformLocation } from '@angular/common';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private readonly location = inject(Location);
  private readonly platformLocation = inject(PlatformLocation);

  getOrigin(): string {
    return (this.platformLocation as any)._location.origin;
  }

  back(): void {
    this.location.back();
  }

  /** Replace current history entry. Use for programmatic redirects and param cleanup. */
  replaceState(path: string, query: string = ''): void {
    this.location.replaceState(path, query);
  }

  private pushState(path: string, query: string = ''): void {
    this.location.go(path, query);
  }

  /** Replace current history entry query string. Use for one-time param cleanup (e.g. clearing ?createFolder). */
  replaceQuery(query = ''): void {
    const path = this.location.path().split('?')[0];
    this.replaceState(path, query);
  }

  /**
   * Push new history entry with query string. Use for user-initiated in-page actions (e.g. search pagination).
   * Bypasses Angular Router (uses Location.go) — does NOT trigger route guards, resolvers, or route subscriptions.
   */
  pushQuery(query = ''): void {
    const path = this.location.path().split('?')[0];
    this.pushState(path, query);
  }

  getAppBaseUrl(): string {
    const origin = this.getOrigin();

    return environment.production || !origin.includes('localhost')
      ? origin
      : environment.backEndUrl;
  }
}
